// Utils
import http from '../../utils/services/http';

// Constants
import { METHODS } from '../../../common/utils/http/httpConstants';

export const registerMobilePushSubscription = (token: string, type: string) =>
    http({
        method: METHODS.POST,
        url: 'notifications/push/register',
        data: {
            deviceToken: token,
            subscriptionType: type,
        },
    }).then((res) => res.data);
